import {EventService} from "./../../../shared/services/event.service";
import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ServerService} from "../../../shared/services/server.service";
import {
  FlatsFloorInfo,
  FloorInfoSet1,
  FloorInfoSet1Ex,
  FloorInfoSet2,
  FloorInfoSet3,
  FloorInfoSet4,
  InfoAboutFlat,
  ISpot,
  OneRoomTypeInfo,
  RoomTypeItem,
} from "../../../shared/models/models";
import {combineLatest} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {CommonModule} from "@angular/common";
import {ModalWindowComponent} from "../../../std-components/modal-window/modal-window.component";
import {FlatsModalComponent} from "../../flats-modal/flats-modal.component";
import { NumberWithSpacesPipe } from "../../../shared/pipes/number-with-spaces.pipe";

@Component({
  selector: "app-flats",
  templateUrl: "./flats.component.html",
  styleUrls: ["./flats.component.scss"],
  standalone: true,
  imports: [CommonModule, ModalWindowComponent, FlatsModalComponent, NumberWithSpacesPipe],
})
export class FlatsComponent implements OnInit {
  @Input() spotObject: ISpot;
  @Input() buildingId: number;
  @Output() confirmEvent: EventEmitter<boolean> = new EventEmitter();

  loading: boolean = false;

  flatsfloorsModal: boolean = false;

  allSets: FlatsFloorInfo;
  set1: FloorInfoSet1[] = [];
  set2: FloorInfoSet2[] = [];
  set3: FloorInfoSet3[] = [];
  set4: FloorInfoSet4[] = [];

  obj: FloorInfoSet1Ex[] = [];
  maxFlatCount: number = 0;
  flatFlag: boolean = false;
  selectedFlat;
  selectedFlatId: number;

  otherRooms1: OtherRoomTypes[] = [];
  otherRooms2: OtherRoomTypes[] = [];
  otherRooms3: OtherRoomTypes[] = [];
  otherRoomMansard: OtherRoomTypes;
  otherRoom201: OtherRoomTypes;
  otherRoom202: OtherRoomTypes;
  otherRoom203: OtherRoomTypes;

  constructor(
    private server: ServerService,
    private event: EventService,
    public toastr: ToastrService
  ) {}

  ngOnInit() {
    this.loadData();
    this.loadBuildingOtherRooms();
    this.event.confirmForFlats.subscribe((res) => {
      if (res) {
        this.loadData();
        this.loadBuildingOtherRooms();
      }
    });
  }

  loadData() {
    this.loading = true;
    this.server.getFlatsFloors(this.buildingId).then((res) => {
      this.allSets = res;
      this.set1 = this.allSets.set1.sort(function (a, b) {
        return b.floorID - a.floorID;
      });
      if (this.set1.length > 0) {
        this.maxFlatCount = this.getMaxFlatCount(this.set1);
      }
      this.obj = this.updateObj(this.allSets);
      this.set2 = this.allSets.set2;
      this.set3 = this.allSets.set3;
      this.set4 = this.allSets.set4;

      this.set1.forEach(floor => {
        const flatsOnThisFloor = this.set4.filter(f => f.floorID === floor.floorID);
        let totalArea = 0;
        flatsOnThisFloor?.filter(f => f.saleDate).forEach(flat => {
          totalArea += flat.flatArea;
        });
        floor.flatArea = totalArea;
      } );
      this.loading = false;
    });
  }

  loadBuildingOtherRooms() {
    combineLatest([
      this.server.getBuildingRooms(1),
      this.server.getBuildingOtherRooms(this.buildingId, 1),
      this.server.getBuildingRooms(2),
      this.server.getBuildingOtherRooms(this.buildingId, 2),
      this.server.getBuildingRooms(3),
      this.server.getBuildingOtherRooms(this.buildingId, 3),
      this.server.getBuildingRooms(-1),
      this.server.getBuildingOtherRooms(this.buildingId, -1),
    ]).subscribe(
      (data) => {
        if (data[0]) {
          this.otherRooms1 = this.updateBuildingOtherRooms(data[0], data[1]);
        }
        if (data[1]) {
          this.otherRooms2 = this.updateBuildingOtherRooms(data[2], data[3]);
          if (this.otherRooms2) {
            this.otherRoom201 = this.otherRooms2.find((x) => x.id === 201);
            this.otherRoom202 = this.otherRooms2.find((x) => x.id === 202);
            this.otherRoom203 = this.otherRooms2.find((x) => x.id === 203);
          }
        }
        if (data[2]) {
          this.otherRooms3 = this.updateBuildingOtherRooms(data[4], data[5]);
        }
        if (data[3]) {
          this.otherRoomMansard = this.updateBuildingOtherRooms(
            data[6],
            data[7]
          )[0];
        }
      },
      () => {},
      () => {
        this.loading = false;
      }
    );
  }

  updateBuildingOtherRooms(rows: RoomTypeItem[], rows2: OneRoomTypeInfo[]) {
    if (rows2.length > 0) {
      let res: OtherRoomTypes[] = [];
      res = rows2.map((r) => {
        return {
          id: r.roomTypeItemID,
          roomTypeID: r.roomTypeID,
          title: "",
          info: {
            area: r.area,
            placeCount: r.placeCount,
            photoFileID: r.photoFileID,
          },
        };
      });
      res.forEach((f) => {
        let r2 = rows.find((r2) => r2.id === f.id);
        f.title = r2.title;
      });
      return res;
    }
    return [];
  }

  getMaxFlatCount(rows: FloorInfoSet1[]) {
    return rows.reduce(function (prev, current) {
      return prev.flatCount > current.flatCount ? prev : current;
    }).flatCount;
  }

  updateObj(rows: FlatsFloorInfo) {
    let res: FloorInfoSet1Ex[] = [];
    res = rows.set1.map((r) => {
      return {
        floorID: r.floorID,
        floorTitle: r.floorTitle,
        flatArea: r.flatArea,
        flatsArr: [],
      };
    });
    res.forEach((f) => {
      let infoCount = 0;
      let flats2 = rows.set2.filter((fi) => fi.floorID === f.floorID);
      let flats1 = rows.set4.filter((fi) => fi.floorID === f.floorID);

      f.flatsArr = flats2.map((fl) => {
        let qwe: InfoAboutFlat[] = [];
        if (flats1.length > 0) {
          // for (let prop in flats1) {

          let flatsByConfigurationID = flats1.filter(
            (flat) => flat.flatConfigurationID === fl.flatConfigurationID
          );
          if (flatsByConfigurationID.length > 0) {
            flatsByConfigurationID.map((flat, index) => {
              let newIndex = qwe.length > 0 ? qwe.length : 0;
              // debugger;
              qwe[newIndex] = {
                flatID: flat.id,
                flatNumber: flat.flatNumber,
                columnID: index + 1,
                roomCountID: fl.roomCountID,
                flatConfigurationID: fl.flatConfigurationID,
                isSale: flat.saleDate !== null ? true : false,
                isCornerFlat: flat.isCornerFlat ? true : false,
                flatArea: flat.flatArea,
              };
            });
          }
        }
        return {
          info: qwe,
        };
      });

      f.flatsArr.map((r) => {
        infoCount += r.info.length;
      });

      if (this.maxFlatCount > infoCount) {
        let infoEx: InfoAboutFlat[] = [];
        for (let i = 0; i < this.maxFlatCount - infoCount; i++) {
          infoEx[i] = {
            flatID: null,
            flatNumber: null,
            columnID: null,
            roomCountID: null,
            flatConfigurationID: null,
            isSale: false,
            isCornerFlat: false,
            flatArea: null,
          };
        }
        f.flatsArr.push({
          info: infoEx,
        });
      }
    });
    return res;
  }
  appModalWindowTitle: string = "";
  openFlat(flat: InfoAboutFlat) {
    this.selectedFlatId = flat.flatID ? flat.flatID : -1;
    this.selectedFlat = flat;
    this.appModalWindowTitle = "Квартира № " + this.selectedFlat.flatNumber;
    this.otherRoomFlag = false;
    this.flatFlag = true;
  }

  otherRoomFlag: boolean;
  openOtherRoom(otherRoom: OtherRoomTypes) {
    this.otherRoomFlag = true;
    this.selectedFlat = otherRoom;
    this.appModalWindowTitle = otherRoom.title;
    this.flatFlag = true;
  }

  reloadData(event) {
    if (event) {
      this.confirmEvent.emit(event);
      this.loadData();
      this.loadBuildingOtherRooms();
    }
  }

  tooglebtn1(i: number, j: number) {
    // this.rowIndexOfFlats = i;
    // this.colIndexOfFlats = j;
    this.flatsfloorsModal = true;
  }

  changes: boolean = false;
  noChanges() {
    this.changes = true;
  }
  acceptNoChanges() {
    this.server.noChangesReal(this.buildingId).then(
      (r) => {
        this.changes = false;
        this.toastr.success("Изменения сохранены!", "Успешно!");
      },
      (err: any) => {
        if (err.status == 500 || err.status == 0) {
          this.toastr.error(
            "К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!",
            "Ваши данные не сохранены!"
          );
        }
      }
    );
  }
}

interface OtherRoomTypes {
  id: number;
  roomTypeID: number;
  title: string;
  info: Info;
}

interface Info {
  area: number;
  placeCount: number;
  photoFileID?: number;
}
